interface ClockIconProps {
  color?: string;
}

export const ClockIcon = ({ color = "#757575" }: ClockIconProps) => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.63538 0C5.55204 0 4.54163 0.276042 3.60413 0.828125C2.69788 1.34896 1.98433 2.0625 1.4635 2.96875C0.911418 3.90625 0.635376 4.91667 0.635376 6C0.635376 7.08333 0.911418 8.09375 1.4635 9.03125C1.98433 9.9375 2.69788 10.6562 3.60413 11.1875C4.54163 11.7292 5.55204 12 6.63538 12C7.71871 12 8.72913 11.7292 9.66663 11.1875C10.5729 10.6562 11.2916 9.9375 11.8229 9.03125C12.3645 8.09375 12.6354 7.08333 12.6354 6C12.6354 4.91667 12.3645 3.90625 11.8229 2.96875C11.2916 2.0625 10.5729 1.34896 9.66663 0.828125C8.72913 0.276042 7.71871 0 6.63538 0ZM6.63538 1C7.54163 1 8.38538 1.22917 9.16663 1.6875C9.91663 2.125 10.5104 2.71875 10.9479 3.46875C11.4062 4.25 11.6354 5.09375 11.6354 6C11.6354 6.90625 11.4062 7.75 10.9479 8.53125C10.5104 9.28125 9.91663 9.875 9.16663 10.3125C8.38538 10.7708 7.54163 11 6.63538 11C5.72913 11 4.88538 10.7708 4.10413 10.3125C3.35413 9.875 2.76038 9.28125 2.32288 8.53125C1.86454 7.75 1.63538 6.90625 1.63538 6C1.63538 5.09375 1.86454 4.25 2.32288 3.46875C2.76038 2.71875 3.35413 2.125 4.10413 1.6875C4.88538 1.22917 5.72913 1 6.63538 1ZM6.13538 2V6.5H9.63538V5.5H7.13538V2H6.13538Z"
      fill={color}
    />
  </svg>
);
